import React, { useContext, useEffect, useState } from 'react'
import { PerformBatteryHeaderStyles } from './Style'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import { AssessmentsContext, batteryViewTypes } from './AssessmentsContext'

const PerformBatteryHeaderCell = (props) => {
    const { column } = props
    const { meta, accessorKey } = column?.columnDef || {}

    const { performBatteryCellView, setPerformBatteryCellView } = useContext(AssessmentsContext)

    const Icon = performBatteryCellView == batteryViewTypes.circle ? ChevronLeft : ChevronRight

    const updatePerformBatteryView = (e) => {
        e.preventDefault()
        e.stopPropagation()
        setPerformBatteryCellView(performBatteryCellView == batteryViewTypes.circle ? batteryViewTypes.details : batteryViewTypes.circle)
    }

    return (
        <PerformBatteryHeaderStyles>
            {"ביצוע"}
            <Icon onClick={updatePerformBatteryView} />
        </PerformBatteryHeaderStyles>
    )
}

export default PerformBatteryHeaderCell